module.exports = __webpack_public_path__ + "img/ru_failure_8.c1e88b09.png";